import { DatePivotParams } from "../../entities/date_pivot_params";
import dayjs from "../../utils/dayjs";

export interface SupplyWalkParams extends DatePivotParams {
  includeAtomicPurchasePlan: string;
}

export const defaultConfig: SupplyWalkParams = {
  dateHierarchy: "week",
  measure: "measure",
  segments: ["sku", "location"],
  minDate: dayjs.utc().startOf("year").toDate(),
  maxDate: dayjs.utc().add(1, "year").startOf("year").toDate(),
  filters: [],
  postFilters: [["has_near_term_purchase", "in", ["true"]]],
  includeAtomicPurchasePlan: "yes",
};
